import React, {useMemo} from 'react'
import Text from '../../../../components/text/Text'
import useQueryGetInvoiceData from '../../../../hooks/api/leader/useQueryGetInvoiceData'
import {useDisplayNumber} from '../../../../utils/number'

interface IProps {
    className?: string
}

const CopyTradingFeeData: React.FC<IProps> = ({className}) => {
    const {data: invoiceData} = useQueryGetInvoiceData()
    const {displayAmount} = useDisplayNumber()

    const renderDate = useMemo(() => {
        const date = String(invoiceData?.data?.when)
        const year = date?.substring(0, 4)
        const month = date?.substring(4, 6)
        const day = date?.substring(6, 8)

        return new Date(`${year}-${Number(month)}-${day}`)
    }, [invoiceData])
    return (
        <div className={'grid grid-cols-3  lg:grid-cols-2 md:grid-cols-1 lg:gap-y-[50px] items-start gap-x-[30px]'}>
            <section className={'space-y-[15px]'}>
                <Text
                    className={
                        'text-center p-[20px] h-[90px] sm:py-[15px] sm:h-[70px] bg-primary/20 rounded-[10px] content-center text-[28px] sm:text-[24px] font-bold'
                    }>
                    Today ({renderDate?.toLocaleDateString()})
                </Text>

                <div
                    className={
                        'bg-white grid grid-cols-2 items-end gap-y-[50px] rounded-[10px] ring-[1px] ring-line02 overflow-hidden p-[20px]'
                    }>
                    <div className={''}>
                        <Text className={'text-font03 lg:text-body3 sm:text-body_comm'}>Today Amount</Text>
                        <Text className={'text-h1 lg:text-h2'}>${invoiceData?.data?.today_amount}</Text>
                    </div>
                    <div className={'text-right'}>
                        <Text className={'text-font03  text-body3 sm:text-body_comm'}>Today Count</Text>
                        <Text className={'text-h2 lg:text-h3'}>{invoiceData?.data?.today_count}</Text>
                    </div>
                    <div className={''}>
                        <Text className={'text-font03 lg:text-body3 sm:text-body_comm'}>Today Paid Amount</Text>
                        <Text className={'text-h1 lg:text-h2 text-font_green'}>
                            ${invoiceData?.data?.today_paid_amount}
                        </Text>
                    </div>
                    <div className={' text-right'}>
                        <Text className={'text-font03 text-body3 sm:text-body_comm'}>Today Paid Count</Text>
                        <Text className={'text-h2 lg:text-h3 text-font_green'}>
                            {invoiceData?.data?.today_paid_count}
                        </Text>
                    </div>
                </div>
            </section>
            <section className={'space-y-[15px]'}>
                <Text
                    className={
                        'text-center p-[20px] h-[90px] sm:py-[15px] sm:h-[70px] bg-alt_blue/20 rounded-[10px] text-[28px] sm:text-[24px] font-bold content-center'
                    }>
                    Monthly ({renderDate?.getMonth() + 1}월)
                </Text>

                <div
                    className={
                        'bg-white grid grid-cols-2 items-end gap-y-[50px] rounded-[10px] ring-[1px] ring-line02 overflow-hidden p-[20px]'
                    }>
                    <div className={''}>
                        <Text className={'text-font03 lg:text-body3 sm:text-body_comm'}>Monthly Amount</Text>
                        <Text className={'text-h1 lg:text-h2'}>
                            ${displayAmount(invoiceData?.data?.month_amount, 1000000)}
                        </Text>
                    </div>
                    <div className={'text-right'}>
                        <Text className={'text-font03 text-body3 sm:text-body_comm'}>Monthly Count</Text>
                        <Text className={'text-h2 lg:text-h3'}>{invoiceData?.data?.month_count}</Text>
                    </div>
                    <div className={''}>
                        <Text className={'text-font03 lg:text-body3 sm:text-body_comm'}>Monthly Paid Amount</Text>
                        <Text className={'text-h1 lg:text-h2 text-font_green'}>
                            ${displayAmount(invoiceData?.data?.month_paid_amount, 1000000)}
                        </Text>
                    </div>
                    <div className={' text-right'}>
                        <Text className={'text-font03 text-body3 sm:text-body_comm'}>Monthly Paid Count</Text>
                        <Text className={'text-h2 lg:text-h3 text-font_green'}>
                            {invoiceData?.data?.month_paid_count}
                        </Text>
                    </div>
                </div>
            </section>

            <section className={'space-y-[15px] lg:col-span-2 md:col-span-1'}>
                <Text
                    className={
                        'text-center p-[20px] h-[90px] sm:py-[15px] sm:h-[70px] bg-tag_orange/20 rounded-[10px] text-[28px] sm:text-[24px] font-bold content-center'
                    }>
                    Total
                </Text>

                <div
                    className={
                        'bg-white grid grid-cols-2 items-end gap-y-[50px] rounded-[10px] ring-[1px] ring-line02 overflow-hidden p-[20px]'
                    }>
                    <div className={''}>
                        <Text className={'text-font03 lg:text-body3 sm:text-body_comm'}>Total Amount</Text>
                        <Text className={'text-h1 lg:text-h2'}>
                            ${displayAmount(invoiceData?.data?.total_amount, 1000000)}
                        </Text>
                    </div>
                    <div className={'text-right'}>
                        <Text className={'text-font03 text-body3 sm:text-body_comm'}>Total Count</Text>
                        <Text className={'text-h2 lg:text-h3'}>{invoiceData?.data?.total_count}</Text>
                    </div>
                    <div className={''}>
                        <Text className={'text-font03 text-body3 sm:text-body_comm'}>Total Paid Amount</Text>
                        <Text className={'text-h1 lg:text-h2 text-font_green'}>
                            ${displayAmount(invoiceData?.data?.paid_amount, 1000000)}
                        </Text>
                    </div>
                    <div className={' text-right'}>
                        <Text className={'text-font03 text-body3 sm:text-body_comm'}>Total Paid Count</Text>
                        <Text className={'text-h2 lg:text-h3 text-font_green'}>{invoiceData?.data?.paid_count}</Text>
                    </div>
                    <div className={''}>
                        <Text className={'text-font03 lg:text-body3 sm:text-body_comm'}>Total Overdue Amount</Text>
                        <Text className={'text-h1 lg:text-h2 text-font_red'}>
                            ${displayAmount(invoiceData?.data?.over_due_amount, 1000000)}
                        </Text>
                    </div>
                    <div className={' text-right'}>
                        <Text className={'text-font03 text-body3 sm:text-body_comm'}>Total Overdue Count</Text>
                        <Text className={'text-h2 lg:text-h3 text-font_red'}>{invoiceData?.data?.over_due_count}</Text>
                    </div>
                    <div />
                    <div className={'text-right'}>
                        <Text className={'text-font03 text-body3 sm:text-body_comm'}>Total Unpaid Count</Text>
                        <Text className={'text-h2 lg:text-h3 text-tag_orange'}>{invoiceData?.data?.unpaid_count}</Text>
                    </div>
                </div>
            </section>
        </div>
    )
}

export default CopyTradingFeeData
